<template>
  <div class="col-md mstabsdetails__content">
    <div class="mstabsdetails__content--title mb-3">COMMODITY DETAILS</div>
      <div class="mt-3 mstabsdetails__content--info">
        <div :class="styletable.row" v-if="getStyleShipmentEntry(detail.freightMode, detail.freightType) !== 'VESSELPACKING'">
          <div :class="styletable.col1">Product Type</div>
          <div :class="styletable.col3">:</div>
          <div :class="styletable.col2">{{getProductType(detail.commoditiesClass)}}</div>
        </div>

        <!-- PO Number -->
          <div :class="styletable.row" v-if="getStyleShipmentEntry(detail.freightMode, detail.freightType) === 'PACKING'">
          <div :class="styletable.col1">PO Number</div>
          <div :class="styletable.col3">:</div>
          <div :class="styletable.col2"> {{mixinConvertSymbol(detail.poNumber, '&') || '-'}}</div>
        </div>

        <!-- Dangerous Goods: UN Number -->
        <div :class="styletable.row"  v-if="detail.commoditiesClass === 'DG'">
          <div :class="styletable.col1">UN Number</div>
          <div :class="styletable.col3">:</div>
          <div :class="styletable.col2"> {{detail.un_number || '-'}}</div>
        </div>

        <!-- HS Code -->
        <div :class="styletable.row">
          <div :class="styletable.col1">HS Code</div>
          <div :class="styletable.col3">:</div>
          <div :class="styletable.col2"> {{detail.commoditiesHSCode || '-'}}</div>
        </div>

        <!-- VESSEL: Load Date -->
        <div :class="styletable.row" v-if="getStyleShipmentEntry(detail.freightMode, detail.freightType) === 'VESSELPACKING'">
          <div :class="styletable.col1">Ready to Load Date</div>
          <div :class="styletable.col3">:</div>
          <div :class="styletable.col2"> {{detail.loadDate ?  getDateFormat2(detail.loadDate ) : '-'}}</div>
        </div>

        <!-- Description / vessel: commodities -->
        <div :class="styletable.row">
          <div :class="styletable.col1">Commodities</div>
          <div :class="styletable.col3">:</div>
          <div :class="styletable.col2" v-if="getStyleShipmentEntry(detail.freightMode, detail.freightType) === 'VESSELPACKING'">
            {{detail.commoditiesType || '-'}}
          </div>
          <div :class="styletable.col2" v-else> {{detail.commoditiesProduct || '-'}}</div>
        </div>

        <!-- RFQ: BARGE & LCT Total Weight -->
        <div :class="styletable.row" v-if="typeRequest === 'RFQ'
                                            &&getStyleShipmentEntry(detail.freightMode, detail.freightType) === 'VESSELPACKING'">
          <div :class="styletable.col1">Total Weight</div>
          <div :class="styletable.col3">:</div>
          <div :class="styletable.col2">{{detail.freights[0].weight | Currency('')}}</div>
        </div>

        <!-- AIR & LCL & AIRBREAKBULK: Volumetric -->
        <div :class="styletable.row"
              v-if="getStyleShipmentEntry(detail.freightMode, detail.freightType) === 'PACKING'">
          <div :class="styletable.col1">Volumetric</div>
          <div :class="styletable.col3">:</div>
          <div :class="styletable.col2"> {{detail.freights[0].volume}} CBM</div>
        </div>
        
        <!-- Packaging : untuk RFQ selain FCL dan LCL Contract -->
        <div v-if="detail.packingList && (typeRequest === 'RFQ'
                  &&  !detail.freightType.includes('FCL')
                  &&  getStyleShipmentEntry(detail.freightMode, detail.freightType) !== 'VESSELPACKING')">
          <div v-for="(listpacking, idx) in 
                    typeRequest === 'RFQ' ? 
                    getJsonStringfy(detail.packingList) : detail.packingList" :key="idx">
            <div class="mt-2 mb-1" style="font-weight: 700"
                v-if="getStyleShipmentEntry(detail.freightMode, detail.freightType) === 'PACKING'">
              Shipment Data <span v-if="typeRequest === 'RFQ'">{{idx + 1}}</span>
            </div>
            <div :class="styletable.row">
              <div :class="styletable.col1" v-if="typeRequest === 'RFQ' || detail.freightType.includes('FCL')">
                {{getName(detail.freightType, 'QTY')}}</div>
              <div :class="styletable.col1" v-else>
                Quantity</div>
              <div :class="styletable.col3">:</div>
              <div :class="styletable.col2">{{listpacking.qty}}</div>
            </div>

            <div :class="styletable.row">
              <div :class="styletable.col1" v-if="typeRequest === 'RFQ' || detail.freightType.includes('FCL')">
                {{getName(detail.freightType, 'WEIGHT')}}</div>
              <div :class="styletable.col1" v-else>Weight</div>
              <div :class="styletable.col3">:</div>
              <div :class="styletable.col2">{{listpacking.weight}} Kg</div>
            </div>

            <!-- Cargo Packaging Type  -->
            <div :class="styletable.row">
              <div :class="styletable.col1">Cargo Packaging Type</div>
              <div :class="styletable.col3">:</div>
              <div :class="styletable.col2">{{listpacking.satuan}}</div>
            </div>

            <div :class="styletable.row" v-if="getStyleShipmentEntry(detail.freightMode, detail.freightType) === 'PACKING'">
              <div :class="styletable.col1">Size Per Package</div>
              <div :class="styletable.col3">:</div>
              <div :class="styletable.col2" v-if="typeRequest === 'RFQ'">
                {{ getDimension(listpacking) }} {{unitDimension}}
              </div>
              <div :class="styletable.col2" v-else>
                {{ getDimension(getJsonStringfyObj(detail.dimension)) }} {{unitDimension}}
              </div>
            </div>
          </div>
        </div>

        <!-- Packaging : VESSEL -->
        <div v-if="detail.packingList && (typeRequest === 'RFQ' &&  getStyleShipmentEntry(detail.freightMode, detail.freightType) === 'VESSELPACKING')">
          <div v-for="(listpacking, idx) in 
                    typeRequest === 'RFQ' ? 
                    getJsonStringfy(detail.packingList) : detail.packingList" :key="idx">
            <div class="mt-3 mb-1" style="font-weight: 700" >
              Product Data <span>{{idx + 1}}</span>
            </div>
            <div :class="styletable.row">
              <div :class="styletable.col1">Product Type</div>
              <div :class="styletable.col3">:</div>
              <div :class="styletable.col2">{{ listpacking.satuan }}</div>
            </div>

            <div :class="styletable.row">
              <div :class="styletable.col1">Product Name</div>
              <div :class="styletable.col3">:</div>
              <div :class="styletable.col2">
                {{ listpacking.productName }}
              </div>
            </div>

            <div :class="styletable.row">
              <div :class="styletable.col1">Length</div>
              <div :class="styletable.col3">:</div>
              <div :class="styletable.col2">
                <span v-if="listpacking.length">{{listpacking.length}} cm</span>
                <span v-else>-</span>
              </div>
            </div>

            <div :class="styletable.row">
              <div :class="styletable.col1">Width/Radius</div>
              <div :class="styletable.col3">:</div>
              <div :class="styletable.col2">
                <span v-if="listpacking.width">{{listpacking.width}} cm</span>
                <span v-else>-</span>
              </div>
            </div>

            <div :class="styletable.row">
              <div :class="styletable.col1">Height</div>
              <div :class="styletable.col3">:</div>
              <div :class="styletable.col2">
                <span v-if="listpacking.height">{{listpacking.height}} cm</span>
                <span v-else>-</span>
              </div>
            </div>

            <div :class="styletable.row">
              <div :class="styletable.col1">Weight per Package</div>
              <div :class="styletable.col3">:</div>
              <div :class="styletable.col2">{{listpacking.weight}} Kg</div>
            </div>

            <div :class="styletable.row">
              <div :class="styletable.col1">Weight per Product</div>
              <div :class="styletable.col3">:</div>
              <div :class="styletable.col2">
                {{ calculateWeightVessel(listpacking.qty, listpacking.weight) | currency('', 0, { spaceBetweenAmountAndSymbol: true }) }} Kg
              </div>
            </div>

            <div :class="styletable.row">
              <div :class="styletable.col1">Quantity</div>
              <div :class="styletable.col3">:</div>
              <div :class="styletable.col2">{{listpacking.qty}}</div>
            </div>

            <div :class="styletable.row">
              <div :class="styletable.col1">Stuffing Notes</div>
              <div :class="styletable.col3">:</div>
              <div :class="styletable.col2">{{listpacking.note || '-'}}</div>
            </div>
          </div>
        </div>

 

        <!-- instant quote-->
        <div v-if="detail.statusShipment === 3 && !detail.freightType.includes('FCL')">
          <div v-for="(listpacking, idx) in JSON.parse(detail.packingList)" :key="idx">
            <div class="mt-2 mb-1" style="font-weight: 700"
                v-if="getStyleShipmentEntry(detail.freightMode, detail.freightType) === 'PACKING'">
              Shipment Data
            </div>
            <div :class="styletable.row">
              <div :class="styletable.col1">
                Quantity</div>
              <div :class="styletable.col3">:</div>
              <div :class="styletable.col2">{{listpacking.qty}}</div>
            </div>

            <div :class="styletable.row">
              <div :class="styletable.col1">Weight</div>
              <div :class="styletable.col3">:</div>
              <div :class="styletable.col2">{{listpacking.weight}} Kg</div>
            </div>

            <div :class="styletable.row">
              <div :class="styletable.col1">Cargo Packaging Type</div>
              <div :class="styletable.col3">:</div>
              <div :class="styletable.col2">{{listpacking.satuan}}</div>
            </div>

            <div :class="styletable.row" v-if="getStyleShipmentEntry(detail.freightMode, detail.freightType) === 'PACKING'">
              <div :class="styletable.col1">Size Per Package</div>
              <div :class="styletable.col3">:</div>
              <div :class="styletable.col2" v-if="typeRequest === 'RFQ'">
                {{ getDimension(listpacking) }} {{unitDimension}}
              </div>
              <div :class="styletable.col2" v-else>
                {{ getDimension(getJsonStringfyObj(detail.dimension)) }} {{unitDimension}}
              </div>
            </div>
          </div>
        </div>

        <div v-if="detail.statusShipment === 3 && detail.freightType.includes('FCL')" class="mb-2">
          <div v-for="(listpacking, idx) in getJsonStringfy(detail.packingList)" :key="idx">
            <div class="mt-3 mb-1 textbold">
              Shipment Data <span>{{idx + 1}}</span>
            </div>
            <div :class="styletable.row">
              <div :class="styletable.col1">FCL Type</div>
              <div :class="styletable.col3">:</div>
              <div :class="styletable.col2">{{listpacking.shipmentType ? getShipmentType(listpacking.shipmentType) : getShipmentType(detail.freightType) }}</div>
            </div>

            <div :class="styletable.row">
              <div :class="styletable.col1">Container Type</div>
              <div :class="styletable.col3">:</div>
              <div :class="styletable.col2">
                {{listpacking.containerType ? listpacking.containerType : detail.freightSubType }}
              </div>
            </div>

            <div :class="styletable.row" v-if="listpacking.containerType === 'Reefer'">
              <div :class="styletable.col1">Temperature</div>
              <div :class="styletable.col3">:</div>
              <div :class="styletable.col2">{{listpacking.temperature ? listpacking.temperature : detail.temperature }} C</div>
            </div>

            <div :class="styletable.row">
              <div :class="styletable.col1">
                Container Quantity
              </div>
              <div :class="styletable.col3">:</div>
              <div :class="styletable.col2">{{listpacking.qty}}</div>
            </div>

            <div :class="styletable.row">
              <div :class="styletable.col1">
                Cargo Packaging Type
              </div>
              <div :class="styletable.col3">:</div>
              <div :class="styletable.col2">{{listpacking.satuan}}</div>
            </div>

            <div :class="styletable.row">
              <div :class="styletable.col1">
                Weight per Container
              </div>
              <div :class="styletable.col3">:</div>
              <div :class="styletable.col2">{{listpacking.weight}} Kg</div>
            </div>

            <div :class="styletable.row">
              <div :class="styletable.col1">
                Container Option
              </div>
              <div :class="styletable.col3">:</div>
              <div :class="styletable.col2">{{listpacking.containerOption ? getContainerOptions(listpacking.containerOption) : getContainerOptions(detail.container_option)}}</div>
            </div>
            
          </div>
        </div>
        <!-- end: Packaging-->

        <!-- Packaging FCL -->
        <div v-if="getType(detail.statusShipment) === 'RFQ' && detail.freightType.includes('FCL')" class="mb-2">
          <div v-for="(listpacking, idx) in getJsonStringfy(detail.packingList)" :key="idx">
            <div class="mt-3 mb-1 textbold">
              Shipment Data <span>{{idx + 1}}</span>
            </div>
            <div :class="styletable.row">
              <div :class="styletable.col1">FCL Type</div>
              <div :class="styletable.col3">:</div>
              <div :class="styletable.col2">{{listpacking.shipmentType ? getShipmentType(listpacking.shipmentType) : getShipmentType(detail.freightType) }}</div>
            </div>

            <div :class="styletable.row">
              <div :class="styletable.col1">Container Type</div>
              <div :class="styletable.col3">:</div>
              <div :class="styletable.col2">
                {{listpacking.containerType ? listpacking.containerType : detail.freightSubType }}
              </div>
            </div>

            <div :class="styletable.row" v-if="listpacking.containerType === 'Reefer'">
              <div :class="styletable.col1">Temperature</div>
              <div :class="styletable.col3">:</div>
              <div :class="styletable.col2">{{listpacking.temperature ? listpacking.temperature : detail.temperature }} C</div>
            </div>

            <div :class="styletable.row">
              <div :class="styletable.col1">
                Container Quantity
              </div>
              <div :class="styletable.col3">:</div>
              <div :class="styletable.col2">{{listpacking.qty}}</div>
            </div>

            <div :class="styletable.row">
              <div :class="styletable.col1">
                Cargo Packaging Type
              </div>
              <div :class="styletable.col3">:</div>
              <div :class="styletable.col2">{{listpacking.satuan}}</div>
            </div>

            <div :class="styletable.row">
              <div :class="styletable.col1">
                Weight per Container
              </div>
              <div :class="styletable.col3">:</div>
              <div :class="styletable.col2">{{listpacking.weight}} Kg</div>
            </div>

            <div :class="styletable.row">
              <div :class="styletable.col1">
                Container Option
              </div>
              <div :class="styletable.col3">:</div>
              <div :class="styletable.col2">{{listpacking.containerOption ? getContainerOptions(listpacking.containerOption) : getContainerOptions(detail.container_option)}}</div>
            </div>
            
          </div>
        </div>
        <!-- end: Packaging FCL -->

        <!-- FCL: Container Type -->
        <div :class="styletable.row" v-if="detail.freightType.includes('FCL') && typeRequest === 'Contract'">
          <div :class="styletable.col1">Container Type</div>
          <div :class="styletable.col3">:</div>
          <div :class="styletable.col2">{{detail.freightSubType || '-' }}</div>
        </div>

        <!-- SEABREAKBULK: UOM -->
        <div :class="styletable.row" v-if="detail.freightType === 'SEABREAKBULK'">
          <div :class="styletable.col1">UOM</div>
          <div :class="styletable.col3">:</div>
          <div :class="styletable.col2">{{jsonStringfypackage[0].uom}}</div>
        </div>

        <!-- FCL: Container Option -->
        <div :class="styletable.row" v-if="detail.freightType.includes('FCL') && typeRequest === 'Contract'">
          <div :class="styletable.col1">Container Option</div>
          <div :class="styletable.col3">:</div>
          <div :class="styletable.col2">{{getContainerOptions(detail.container_option)}}</div>
        </div>

        <!-- SEABREAKBULK & FCL: Estimate Total Weight -->
        <div :class="styletable.row"
              v-if="getStyleShipmentEntry(detail.freightMode, detail.freightType) === 'DEFAULT'">
          <div :class="styletable.col1">Estimate Total Weight</div>
          <div :class="styletable.col3">:</div>
          <div :class="styletable.col2">{{detail.weight_estimation}} {{unitTotalWeight}}</div>
        </div>

        <!-- SEABREAKBULK: Qty Per Packaging  -->
        <div :class="styletable.row" v-if="detail.freightType === 'SEABREAKBULK'">
          <div :class="styletable.col1">Qty Per Packaging</div>
          <div :class="styletable.col3">:</div>
          <div :class="styletable.col2">{{jsonStringfypackage[0].qtyperPackage}}</div>
        </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import mixinDate from '@/mixin/getters/date-time'
import mixinShipmentDetails from '@/mixin/getters/shipment-details'
import mixinFunctions from '@/mixin/getters/functions'

export default {
  name: 'CommodityDetails',
  mixins: [mixinDate, mixinShipmentDetails, mixinFunctions],
  computed: {
    ...mapGetters({
      detail: 'shipment/item',
      isLoading: 'shipment/isLoading',
      isError: 'shipment/error',
      // update detail
      updated: 'shipment/isUpdated',
      isUpdating: 'shipment/isUpdating' // loading
    })
  },
  data: () => ({
    styletable: {
      row: 'row m-0 mb-1',
      col1: 'col-md-4 pl-0',
      col2: 'col-md pl-1 textcolor textbold',
      col3: 'col-md-0'
    },
    jsonStringfypackage: [],
    unitDimension: '',
    unitTotalWeight: '',
    typeRequest: ''
  }),
  mounted () {
    this.modifyPackingList()
  },
  methods: {
    getStyleShipmentEntry (service, type) {
      let style = 'DEFAULT'
      if (service === 'AIR' || type === 'SEALCL') { // multi dimension
        style = 'PACKING'
      } else if (type === 'SEABREAKBULK') { // singel dimension
        style = 'DEFAULT'
      } else if (type.includes('FCL')) { // fcl multi dimension
        style = 'FCLPACKING'
      } else if (type === 'BARGE' || type === 'LCT') { // vessel
        style = 'VESSELPACKING'
      }
      return style
    },

    getName (shipmenType, type) {
      let currentname = ''
      if (shipmenType && (shipmenType.toUpperCase().includes('FCL') ||
                          shipmenType.toUpperCase() === 'SEABREAKBULK')) {
        if (type === 'QTY') {
          currentname = 'Container Quantity'
        }
        if (type === 'STYPE') {
          if (shipmenType.toUpperCase() === 'SEABREAKBULK') {
            currentname = 'Shipment Type'
          } else {
            currentname = 'FCL Type'
          }
        }
        if (type === 'WEIGHT') {
          currentname = 'Weight Per Container'
        }
      } else {
        if (type === 'QTY') {
          currentname = 'Packages Quantity'
        }
        if (type === 'STYPE') {
          currentname = 'Shipment Type'
        }
        if (type === 'WEIGHT') {
          currentname = 'Weight Per Package'
        }
      }
      return currentname
    },
    getDimension (dimension) {
      let dimensions = ''
      if (dimension) {
        dimensions = (`${dimension.length ? dimension.length : '0'} x ${dimension.width
          ? dimension.width : '0'} x ${dimension.height ? dimension.height : '0'}`)
      }
      return dimensions
    },
    getContainerOptions (type) {
      if (type === 'SOC') {
        return "Shipper's Own Container (SOC)"
      } if (type === 'COC') {
        return "Carrier's Owned Container (COC)"
      }
      return ''
    },

    getJsonStringfy (obj) {
      const stringify = JSON.parse(obj)
      let result = []
      for (var i = 0; i < stringify.length; i++) {
        result[i] = stringify[i]
      }
      return result
    },

    modifyPackingList () {
      this.typeRequest = this.getType(this.detail.statusShipment)
      if (this.typeRequest === 'CONTRACT') {
        const data = this.detail.freights[0]
        const packingList = [{
          qty: data.qty,
          weight: data.weight,
          satuan: this.detail.satuan
        }]
        this.detail.packingList = packingList
        this.jsonStringfypackage = packingList
      }

      if (this.typeRequest === 'RFQ') {
        this.jsonStringfypackage = this.getJsonStringfy(this.detail.packingList)
      }

      if (this.detail.freightType.includes('FCL')) {
        this.unitTotalWeight = 'Kg'
      } else if (this.detail.freightType === 'SEABREAKBULK') {
        this.unitTotalWeight = 'Kg' // Ton
        this.unitDimension = 'm'
      } else {
        this.unitDimension = 'cm'
      }
    },
    getType (statusShipment) {
      let type = ''
      switch (statusShipment) {
        case 1 :
          type = 'RFQ'
          break
        case 2 :
          type = 'CONTRACT'
          break
        default :
          type = ''
      }
      return type
    },

    getJsonStringfyObj (obj) {
      return JSON.parse(obj)
    },

    calculateWeightVessel(qty, weight) {
      return parseFloat(qty) * parseFloat(weight)
    }
  },
  watch: {
    detail (data) {
      if (data) {
        this.modifyPackingList()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/managementShipment/detail/tab-detail/CommodityDetails.vue